import { Button } from '@chakra-ui/react';

import * as types from 'types';
import { PageHeader } from 'shared-components';

import PageSubtext from '../../../../atoms/PageSubtext';

interface IProps {
  config: types.SectionConfig;
  goToTravelStatusTab: () => void;
}

export const Header = ({ goToTravelStatusTab, config: { summary, summaryLabel } }: IProps) => {
  const redirectToEnrolmentStatusTab = () => {
    goToTravelStatusTab();
  };

  return (
    <>
      <PageHeader dataSelector="Dashboard-Header">{summaryLabel}</PageHeader>

      <PageSubtext>
        {summary} If your plans have changed,{' '}
        <Button variant="link" onClick={() => redirectToEnrolmentStatusTab()}>
          update your travel status
        </Button>
        .
      </PageSubtext>
    </>
  );
};
